<template>
    <b-card no-body>

        <b-modal id="update" :title="['Güncelle',param.VisibleName || null].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <system-parameter-update v-model="param"></system-parameter-update>
            <template #modal-footer><v-executer :action="update" text="Güncelle" :loading="loading"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    with-items
                    :items="params"
                    search
                    :settings=false
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { SystemParameterApi } from '@/api/system-parameter'
import { BCard } from 'bootstrap-vue'
import Parameters from '@/utilities/parameters'
import SystemParameterUpdate from './components/SystemParameterUpdate.vue'

export default {
    components:{
        BCard,
        SystemParameterUpdate
    },
    data() {
        return {
            loading:false,
            fields:[
                {name:'Anahtar',key:'VisibleName',thClass:'w-50'},
                {name:'Değer',key:'Value',thClass:'w-50'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit }
            ],
            param:{
                Id:null,
                VisibleName:null,
                Value:null
            }
        }
    },
    methods:{
        clearForm(){
            this.param.Id = null
            this.param.VisibleName = null
            this.param.Value = null
        },
        edit(item){
            this.clearForm()
            this.param.Id = item.Id
            this.param.VisibleName = item.VisibleName
            this.param.Value = item.Value
            this.$showModal('update')
        },
        update(){
            this.loading = true
            SystemParameterApi.Update(this.param).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.setLoading(true)
                    Parameters.loadParameters().then(()=>this.$refs.table.setLoading(false))
                    this.$hideModal('update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        params(){
            return Parameters.parameters
        }
    }
}
</script>

<style>

</style>